
<template>
  <el-dialog
    title="导入课程管理"
    :visible.sync="value"
    width="80%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="detailForm"
      :rules="rules"
      :model="model"
    >
      <el-table :data="model.uploadData">
        <!-- 课程名称 -->

        <el-table-column label="课程名称" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.keChengName'"
              :rules="rules.keChengName"
            >
              <el-input
                v-model="scope.row.keChengName"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 课程类型 -->

        <el-table-column label="课程类型" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.keChengDictKey'"
              :rules="rules.keChengDictKey"
            >
              <el-select
                v-model="scope.row.keChengDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D08')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 授课方式 -->

        <el-table-column label="授课方式" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.shouKeDictKey'"
              :rules="rules.shouKeDictKey"
            >
              <el-select
                v-model="scope.row.shouKeDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D09')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 总课时 -->

        <el-table-column label="总课时" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.totalKeShi'"
              :rules="rules.totalKeShi"
            >
              <el-input-number
                v-model="scope.row.totalKeShi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 专业 -->

        <el-table-column label="专业" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.zhuanYeDictKey'"
              :rules="rules.zhuanYeDictKey"
            >
              <el-select
                v-model="scope.row.zhuanYeDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D10')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 教学组长 -->

        <el-table-column label="教学组长" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jiaoXueZuZhang'"
              :rules="rules.jiaoXueZuZhang"
            >
              <el-input
                v-model="scope.row.jiaoXueZuZhang"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 教学助理 -->

        <el-table-column label="教学助理" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jiaoXueZhuLi'"
              :rules="rules.jiaoXueZhuLi"
            >
              <el-input
                v-model="scope.row.jiaoXueZhuLi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 角色 -->

        <el-table-column label="角色" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jueSeDictKey'"
              :rules="rules.jueSeDictKey"
            >
              <el-select
                v-model="scope.row.jueSeDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D11')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 开始日期 -->
        <el-table-column label="开始日期" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.kaiShiRiQi'"
              :rules="rules.kaiShiRiQi"
            >
              <el-date-picker
                v-model="scope.row.kaiShiRiQi"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 结束日期 -->
        <el-table-column label="结束日期" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.jieShuRiQi'"
              :rules="rules.jieShuRiQi"
            >
              <el-date-picker
                v-model="scope.row.jieShuRiQi"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 学制Key -->

        <el-table-column label="学制Key" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.xueZhiDictKey'"
              :rules="rules.xueZhiDictKey"
            >
              <el-select
                v-model="scope.row.xueZhiDictKey"
                filterable
                clearable
                size="small"
              >
                <el-option
                  v-for="item in getComboxData('D12')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 年级 -->
        <el-table-column label="年级" align="center" width="180">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.nianJi'"
              :rules="rules.nianJi"
            >
              <el-date-picker
                v-model="scope.row.nianJi"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 班级 -->

        <el-table-column label="班级" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.banJi'"
              :rules="rules.banJi"
            >
              <el-input
                v-model="scope.row.banJi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 学员数 -->

        <el-table-column label="学员数" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.xueYuanShu'"
              :rules="rules.xueYuanShu"
            >
              <el-input-number
                v-model="scope.row.xueYuanShu"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 理论课时 -->

        <el-table-column label="理论课时" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.liLunKeShi'"
              :rules="rules.liLunKeShi"
            >
              <el-input-number
                v-model="scope.row.liLunKeShi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 实践课时 -->

        <el-table-column label="实践课时" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.shiJianKeShi'"
              :rules="rules.shiJianKeShi"
            >
              <el-input-number
                v-model="scope.row.shiJianKeShi"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <!-- 备注 -->

        <el-table-column label="备注" align="center" width="150">
          <template slot-scope="scope">
            <el-form-item
              :prop="'uploadData.' + scope.$index + '.remarks'"
              :rules="rules.remarks"
            >
              <el-input
                v-model="scope.row.remarks"
                size="small"
              />
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>
              <el-button
                type="text"
                size="small"
                @click.stop="handleRowDel( scope.row,scope.$index)"
              >
                删除
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleUploadData('detailForm')"
      >保  存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'

export default {
  components: { },
  props: {
    value: Boolean,
    uploadData: { type: Array, default: null }},
  data() {
    return {
      model: { uploadData: {}},
      allComboxData: [],
      formCode: 'jx01',
      rules: {
      }
    }
  },
  watch: {
    uploadData: function() {
      this.model.uploadData = this.uploadData
    }
  },
  mounted: function() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D08;D09;D10;D11;D12').then(res => {
      this.allComboxData = res.data.result
    })
    this.model.uploadData = this.uploadData
  },
  methods: {
    handleOpenDailog() {},
    handleCloseDailog() {
      this.$emit('input', false)
    },
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 保存数据
    handleUploadData() {
      this.$refs['detailForm'].validate(valid => {
        if (valid) {
          const url = '/api/services/app/jx01/ImportCreatejx01'
          pathReq.postForm(url,
            { entityList: this.model.uploadData }
          ).then(() => {
            this.$message.success('导入成功')
            this.$emit('input', false)
            this.$emit('save-success')
          })
        }
      })
    },
    handleRowDel(row, index) {
      this.model.uploadData.splice(index, 1)
    }
  }
}
</script>
